import { useNavigate } from '@/routing'
import { FormattedMessage } from 'react-intl'

import { Alert, AlertTitle, Button, Stack, Typography } from '@mui/material'

import { useLiveEtaStatus } from '../../../../../../hooks/useLiveEtaStatus'

import { useCallback } from 'react'
import { useTexts } from './useTexts'

export function NotificationLimitations() {
  const liveEtaStatus = useLiveEtaStatus()
  const texts = useTexts()
  const navigate = useNavigate(true)

  const navigateToVehicles = useCallback(() => {
    navigate('vehicles')
  }, [navigate])

  switch (liveEtaStatus) {
    case 'notAvailableForTheUser':
      return (
        <Alert severity="warning">
          <AlertTitle>{texts.liveEtaNotAvailableForUserTitle}</AlertTitle>
          {texts.liveEtaNotAvailableForUserDescription}
        </Alert>
      )

    case 'notActive':
      return (
        <Alert severity="error">
          <AlertTitle>{texts.liveEtaRequiredTitle}</AlertTitle>
          {texts.liveEtaRequiredDescription}
        </Alert>
      )
    case 'notActiveOnAllVehicles':
      return (
        <Alert severity="info">
          <AlertTitle>{texts.liveEtaRequiredOnAllVehiclesTitle}</AlertTitle>

          <Stack direction="column" spacing={1} alignItems="start">
            <Typography variant="body2">
              <FormattedMessage
                id="info-description"
                defaultMessage={texts.liveEtaRequiredOnAllVehiclesDescription}
                values={{
                  b: chunks => (
                    <Typography fontWeight={500} display="inline">
                      {chunks}
                    </Typography>
                  ),
                  br: _ => <br />,
                }}
              />
            </Typography>
            <Button variant="text" onClick={navigateToVehicles}>
              {texts.navigateToVehiclesLabel}
            </Button>
          </Stack>
        </Alert>
      )
    default:
      return null
  }
}
